import { NO_GATE } from "constants/proposals";

export const MOVE_DIRECTION = { FORWARD: "FORWARD", BACKWARD: "BACKWARD" };

const EMPTY_RESULT = { needsPrompt: false, crossedGates: [], direction: null };

export const computeGateInterception = ({ columns, gateMode, prevColumnId, nextColumnId }) => {
  const sorted = [...(columns || [])].sort((a, b) => a.position - b.position);
  const from = sorted.find((column) => column.id === prevColumnId);
  const to = sorted.find((column) => column.id === nextColumnId);
  if (!from || !to || from.id === to.id) {
    return EMPTY_RESULT;
  }

  const direction =
    to.position > from.position ? MOVE_DIRECTION.FORWARD : MOVE_DIRECTION.BACKWARD;
  if (direction === MOVE_DIRECTION.BACKWARD) {
    return { needsPrompt: false, crossedGates: [], direction };
  }

  const fromIndex = sorted.indexOf(from);
  const toIndex = sorted.indexOf(to);

  const crossedGates = sorted.slice(fromIndex, toIndex).map((column, index) => ({
    columnId: column.id,
    title: column.title,
    toTitle: sorted[fromIndex + index + 1].title,
    questions: column.questions || [],
  }));

  const hasQuestions = crossedGates.some((gate) => gate.questions.length > 0);
  const needsPrompt = gateMode !== NO_GATE && hasQuestions;

  return { needsPrompt, crossedGates, direction };
};
